<template>
  <div class="SNSCancelConfirmation">
    <section-header v-if="sns === 'Twitter'" heading="2" :ja="'X(旧' +sns + ')連携解除確認'" />
    <section-header v-else heading="2" :ja="sns + '連携解除確認'" />
    <div class="description">
      <template v-if="accountCount > 1">{{ isSnsText }} 連携を解除しますか？</template>
      <template v-else>解除できません</template>
    </div>
    <normal-btn @click="onOK">OK</normal-btn>
    <normal-btn v-if="accountCount > 1" @click="onCancel">キャンセル</normal-btn>
  </div>
</template>

<script>
import NormalBtn from "../components/NormalBtn"
import SectionHeader from "../components/SectionHeader"
import Protobuf from "../mixins/protobuf"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "SNSCancelConfirmation",
  components: {
    NormalBtn,
    SectionHeader,
  },
  mixins: [Protobuf],
  data () {
    return {
      accountCount: 0,
      mailAddress: null,
      lineUserId: null,
      twitterUserId: null,
    }
  },
  computed: {
    sns() {
      return this.$route.params.sns
    },
    isLINE() {
      return this.sns === 'LINE'
    },
    isTwitter() {
      return this.sns === 'Twitter'
    },
    isSnsText(){
      if(this.sns === 'Twitter'){
        return 'X(旧Twitter)'
      } else {
        return this.$route.params.sns
      }
    },
    canRemove() {
      const count = this.$store.getters.accountCount
      return count > 1
    }
  },
  mounted() {
    const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
    const message = pb.PlayerInfoReq.create()
    const encoded = pb.PlayerInfoReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        if(decoded.mailAddress) this.accountCount++;
        if(decoded.lineUserId) this.accountCount++;
        if(decoded.twitterUserId) this.accountCount++;
      })
      .catch(() => {
        this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
      })
  },
  methods: {
    onCancel() {
      this.$router.back()
    },
    message() {
      if (this.isLINE) {
        return pb.PlayerUpdateInfoReq.create({
          updateType: pb.PlayerUpdateInfoReq.UpdateType.LINE,
          lineUserId: '',
          lineAccessToken: '',
        })
      }
      if (this.isTwitter) {
        return pb.PlayerUpdateInfoReq.create({
          updateType: pb.PlayerUpdateInfoReq.UpdateType.TWITTER,
          twitterUserId: '',
          twitterAccessToken: '',
          twitterAccessTokenSecret: ''
        })
      }
      return null
    },
    removeAccessToken() {
      if (this.isLINE) {
        this.$store.dispatch('removeLineAccessToken')
      } else if (this.isTwitter) {
        this.$store.dispatch('removeTwitterAccessToken')
      }
    },
    onOK() {
      if (this.accountCount <= 1) {
        this.$router.back()
        return
      }
      const cmdNo = pb.PlayerUpdateInfoReq.CommandNo.COMMAND_NO
      const message = this.message()
      if (message == null) {
        return
      }
      const encoded = pb.PlayerUpdateInfoReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
            this.removeAccessToken()
            this.$router.back()
          } else {
            this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
        })
    }
  }
}
</script>

<style scoped>
.description {
  font-size: 14px;
  color: #373737;
  margin: 30px 30px 0;
}
</style>
